// gatsby-browser.js
import "@fontsource/roboto";
import "./src/styles/foundation/variable.css";
import "./src/styles/foundation/normalize.css";
import "./src/styles/foundation/base.css";
import "./src/styles/foundation/blog-contents-style.css";

// ページ遷移後にトップへスクロール
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window !== "undefined") {
    // スムーズスクロールで少し遅延させると確実
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, 50);
  }

  // フェードイン処理
  if (typeof document !== "undefined") {
    const elements = document.querySelectorAll(".fadeInUp");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on");
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }
};

// JS 動作判定用
export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js");
  }
};